import { axiosInstance } from "./config"

export const login = async(data)=>{
    const response = await axiosInstance.post('/login',data)
    return response.data
}

export const register = async(data)=>{
    const response = await axiosInstance.post('/register',data)
    return response.data
}

export const getCustomerToken = async()=>{
    const response = await axiosInstance.get('/customer-token')
    return response.data
}

export const getCustomer = async(id)=>{
    const response = await axiosInstance.get(`/customers/${id}`)
    return response.data
}

export const logout = async()=>{
    const response = await axiosInstance.post('/logout')
    return response.data
}
export const updateCustomer = async(id,data)=>{
    const response = await axiosInstance.put(`/customers/${id}`,data)
    return response.data
}

export const createOrder = async(data)=>{
    const response = await axiosInstance.post('/orders',data)
    return response.data
}

export const getAllBanner = async()=>{
    const response = await axiosInstance.get('/banners')
    return response.data
}